import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useDocumentTitleNotifications = () => {
  const unseenCount = useSelector(
    (state) => state.messageReducer?.unseenCount || 0
  );

  // Track window focus
  const [windowFocused, setWindowFocused] = useState(true);

  useEffect(() => {
    const handleFocus = () => {
      setWindowFocused(true);
      // setUnreadCount(0); // reset count when user returns
    };
    const handleBlur = () => setWindowFocused(false);

    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);

    return () => {
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
    };
  }, []);

  useEffect(() => {
    if (!windowFocused && Number(unseenCount) && unseenCount > 0) {
      // Count only messages from others
      // const newUnread = messages.filter(msg => msg.senderId !== currentUserId).length;
      // setUnreadCount(newUnread);
      document.title = `(${unseenCount}) New message${
        unseenCount > 1 ? "s" : ""
      }`;
    } else {
      document.title = "COMTRACKED"; // default title
    }
  }, [unseenCount, windowFocused]);

  // return unreadCount;
};

export default useDocumentTitleNotifications;
